import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useFetch(path, deps = [], { poll } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!path) return;
    try {
      const res = await api.get(path);
      setData(res.data);
      setError(null);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, ...deps]);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    if (!poll) return undefined;
    const t = setInterval(() => {
      if (document.visibilityState === "visible") load();
    }, poll);
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    return () => {
      clearInterval(t);
      window.removeEventListener("focus", onFocus);
    };
  }, [poll, load]);

  return { data, loading, error, reload: load, setData };
}

export const useMembers = () => useFetch("/members");
export const useEvents = () => useFetch("/events?upcoming=false");
